import { LevelMap } from "../../engine/map/LevelMap";
import { ComponentF } from "../ui";
import { drawWorld, gameData, handleInput } from "../../core/GameManager";
import { Bounds, Point } from "../../engine/space/bounds";

const getViewport = (map: LevelMap<any, any>, focus: Point, bounds: Bounds) => {
  const halfw = bounds.w / 2;
  const halfh = bounds.h / 2;
  return {
    x: Math.floor(Math.max(0, Math.min(map.width - bounds.w, focus.x - halfw))),
    y: Math.floor(
      Math.max(0, Math.min(map.height - bounds.h, focus.y - halfh))
    ),
    w: Math.min(bounds.w, map.width),
    h: Math.min(bounds.h, map.height),
  };
};

export const MapUI: ComponentF<{ title: string; onClick: () => void }> = (
  C
) => {
  C.handlers.keypress = handleInput;

  const target = gameData.targetFocus;
  drawWorld(
    C.display,
    C.bounds,
    getViewport(
      gameData.current,
      target
        ? { x: target.x, y: target.y }
        : { x: gameData.player.x, y: gameData.player.y },
      C.bounds
    )
  );
};
